/* eslint-disable no-unused-vars */



import BaseCanvasEdit2 from './base_canvas_edit_2'
import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from "react"
import { Row, Col, Spin, message, Button, useCRUDController, TempDataProvider, } from './ot'
import { useNavigate, useSearchParams, } from "react-router-dom";
const BaseDocumentResponseCanvasEdit = forwardRef(({
    dbCoverId = null,
    dbCoverIdName = "document_id",
    responseValue = null,
    mainApiRoute = "/utility/document",
    reponseApiRoute = "/utility/response/cache",
    showSubmit = false,
    showToolbar = false,
    axiosMode = "post", // 新增: "post" 或 "patch" 還有get
    onFinish = () => { },
    processResponseData = (item) => { return item },
    defaultRecord,
    preloadedDocument = null,  // 新增
    propsCanvasMode = "auto",
    autoFitWidth,
    editableFieldCodes = null,
}, ref) => {
    const baseCanvasEdit2Ref = useRef()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    // const xDocumentId = searchParams?.get(dbCoverIdName)
    const [documentId, setDocumentId] = useState(dbCoverId); // 新增
    const [canvasElement, setCanvasElement] = useState([]); //可以定義為defaultCanvasElement的值
    const [tempCanvasElement, setTempCanvasElement] = useState([]); //可以定義為CanvasElement的緩存結果
    const [columns, setColumns] = useState([])
    const [loading, setLoading] = useState(false);
    const payloadRef = useRef()

    // const dbCoverId = searchParams?.get(dbCoverIdName)
    function convertResponsesToCodeValueMap(responses) {
        return responses.map(response => {
            const result = {};
            (response.response_form_value_data || []).forEach(item => {
                const formColumnData = item.form_column_form_value_data?.[0];
                if (formColumnData && formColumnData.code !== undefined) {
                    result[formColumnData.code] = item.value?.value;
                }
            });
            return result;
        });
    }
    const getData = (dbCoverId, selectionData) => {
        mainApiController.getData({
            [dbCoverIdName]: dbCoverId
        })
            .then((res) => {
                initCanvasFromDocument(res?.data)  // ← 共用同一個 function

            })
            .catch((error) => {
                // 處理錯誤
            });
    }
    function convertCanvasToResponseData(pages, documentId = 1, type = 1, getItem) {
        // 預設只處理第一頁
        const page = Array.isArray(pages) ? pages[0] : pages;
        const response_form_value_data = [];

        (page.elements || []).forEach((element, idx) => {
            // 只處理有 form_column_id 的元件
            if (!element.form_column_id) return;

            // 判斷是否選項型元件
            const isOption = ["dropdown", "radio_button", "multi_select_list", "checkbox"].includes(element.type) ? 1 : 0;

            // value_type
            let value_type = element?.type;

            // value 格式
            let valueObj;
            if (isOption) {
                // 多選用 array，單選用 id
                if (Array.isArray(element.content)) {
                    valueObj = { value: element.content.map(v => Number(v)) };
                } else {
                    valueObj = { value: Number(element.content) };
                }
            } else {
                valueObj = { value: element.content };
            }

            // ✅ 即時從 global store 取最新 response_data
            const docId = element
                ?.form_form_column_data?.[0]
                ?.form_column_source_data?.[0]
                ?.document_source_data?.[0]
                ?.document_id;

            const latestResponseData = docId && getItem
                ? (getItem(docId)?.response_data ?? [])
                : (element
                    ?.form_form_column_data?.[0]
                    ?.form_column_source_data?.[0]
                    ?.document_source_data?.[0]
                    ?.response_data ?? []);

            // 將當前選擇的 value 轉為陣列，方便統一比對
            const selectedValues = Array.isArray(valueObj?.value)
                ? valueObj.value
                : [valueObj?.value];

            // ✅ 用最新 response_data 比對出 extra_data
            const extra_data = latestResponseData
                .find(item => selectedValues.includes(item?.response_id))
                ?.response_form_value_data;

            // 取得 form_value_id (for patch)
            let form_value_id = element?.form_form_column_data?.[0]?.form_value_id;

            // 取得 response_form_value_id (for patch)
            let response_form_value_id = null;
            if (axiosMode === "patch" && Array.isArray(responseValue?.response_form_value_data)) {
                // 依 code 對應
                const code = element?.form_form_column_data?.[0]?.code;
                const found = responseValue.response_form_value_data.find(
                    item => item.form_column_form_value_data?.[0]?.code === code
                );
                if (found) {
                    response_form_value_id = found.response_form_value_id;
                }
            }

            let base = {
                form_column_form_value_data: [
                    {
                        form_column_id: element.form_column_id,
                        code: element?.form_form_column_data?.[0]?.code
                    }
                ],
                is_option: isOption,
                index: idx + 1,
                value: valueObj,
                value_type,
                extra_data, // ✅ 已是最新值
            };

            if (axiosMode === "patch") {
                if (response_form_value_id) base.response_form_value_id = response_form_value_id;
            }

            response_form_value_data.push(base);
        });

        // 回傳格式依 post/patch
        if (axiosMode === "patch") {
            return {
                response_id: responseValue?.response_id,
                document_id: documentId,
                response_form_value_data
            };
        } else {
            return [
                {
                    type,
                    document_response_data: [
                        {
                            document_id: documentId
                        }
                    ],
                    response_form_value_data
                }
            ];
        }
    }
    const getCurrentResponseData = React.useCallback(() => {
        const responseData_ = convertCanvasToResponseData(tempCanvasElement, dbCoverId, "1");
        // const responseData = processResponseData(responseData_)
        return responseData_
    }, [tempCanvasElement, dbCoverId, axiosMode, responseValue]);
    // 新增: 封裝 submit/post/patch
    // 讓外部 ref 觸發 onSubmit
    const handleSubmit = React.useCallback(() => {
        // 1. 檢查必填欄位
        const page = Array.isArray(tempCanvasElement) ? tempCanvasElement[0] : tempCanvasElement;
        const elements = page?.elements || [];
        let missingFields = [];

        elements.forEach((element) => {
            // 判斷是否必填
            const isRequired = element?.form_form_column_data?.[0]?.is_required === "1" && element?.hidden !== 1
            if (isRequired) {
                // 判斷內容是否有填寫（支援 0、false、空字串都算沒填）
                const value = element?.content;
                const isEmpty = value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0);
                if (isEmpty) {
                    missingFields.push(element?.form_form_column_data?.[0]?.code || "未命名欄位");
                }
            }
        });

        if (missingFields.length > 0) {
            message.error(`請填寫所有必填欄位：${missingFields.join("、")}`);
            return false;
        }
        // 透過 ref 拿最新 getItem
        const storeGetItem = baseCanvasEdit2Ref.current?.getStoreItem;
        // 2. 通過檢查才送出
        const responseData_ = convertCanvasToResponseData(
            tempCanvasElement,
            dbCoverId,
            "1",
            storeGetItem  // ✅ 傳入
        );
        const responseData = processResponseData(responseData_)
        if (axiosMode === "patch") {
            payloadRef.current = [responseData]
            responseUtilityController.patchData([responseData]);
        } else {
            payloadRef.current = responseData
            responseUtilityController.postData(responseData);
        }
        return responseData
    }, [tempCanvasElement, dbCoverId, axiosMode, responseValue]);

    // 將 onSubmit 提供給外部 ref 呼叫（正確用法）
    useImperativeHandle(ref, () => ({
        submit: handleSubmit,
        getCurrentResponseData: getCurrentResponseData,
        getcurrentCanvasElement: () => {
            return baseCanvasEdit2Ref.current ? baseCanvasEdit2Ref.current.getCurrentCanvasElement() : [];
        }
    }), [handleSubmit, tempCanvasElement]);
    const mainApiController =
        useCRUDController({
            onFinish: ({ axiosMode, status, values }) => {
                if (status === "success") {
                    if (axiosMode === "post") {
                        message.success("新增成功")
                        // navigate(`${pageFrontendRoute}?` + jsonToQueryString({ [dbCoverIdName]: values?.[dbCoverIdName] }))
                    } else if (axiosMode === "patch") {
                        message.success("修改成功")
                        // getData(dbCoverId)
                    }
                }
                else if (status === "error") {
                    if (axiosMode === "post") {
                        message.error("新增失敗")
                    }
                    else if (axiosMode === "patch") {
                        message.error("修改失敗")
                    }
                }
                setLoading(false)
            },
            onBefore: ({ axiosMode, status, values }) => {
                setLoading(true)
            },
            apiRoute: mainApiRoute,
        });
    const responseUtilityController = useCRUDController({
        apiRoute: reponseApiRoute,
        onBefore: ({ axiosMode }) => {
            if (axiosMode !== "get") {
                // setLoading(true);
            }
        },
        onFinish: ({ axiosMode, status, values }) => {
            onFinish({ axiosMode, status, values, payload: payloadRef.current })
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success("新增成功")
                    // setReloadAndResetCount((pre) => pre + 1)
                } else if (axiosMode === "patch") {
                    message.success("修改成功")
                    // setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.success("刪除成功")
                    // setReloadAndResetCount((pre) => pre + 1)

                }
            }
            else if (status === "error") {
                if (axiosMode === "post") {
                    message.error("新增失敗")
                    // setReloadAndResetCount((pre) => pre + 1)

                }
                else if (axiosMode === "patch") {
                    message.error("修改失敗")
                    // setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.error("刪除失敗")
                    // setReloadAndResetCount((pre) => pre + 1)
                }
            }
            if (axiosMode !== "get") {
                // setLoading(false)
                // setModalOpen(false);
            }
        }
    })

    // 根據 code 對應填值
    function fillCanvasElementWithResponse(canvasElement, response_form_value_data) {
        if (!Array.isArray(canvasElement) || !Array.isArray(response_form_value_data)) return canvasElement;
        // 建立 code->value, code->form_value_id 對應表
        const codeValueMap = {};
        const codeFormValueIdMap = {};
        console.log({ response_form_value_data })
        response_form_value_data.forEach((item) => {
            const code = item?.form_column_form_value_data?.[0]?.code;
            if (code) {
                codeValueMap[code] = item.value?.value;
                codeFormValueIdMap[code] = item.form_value_id;
            }
        });
        // 填入 content 與 form_value_id
        return canvasElement.map((page) => {
            if (!page.elements) return page;
            return {
                ...page,
                elements: page.elements.map((el) => {
                    const code = el?.form_form_column_data?.[0]?.code;
                    if (code && (codeValueMap.hasOwnProperty(code) || codeFormValueIdMap.hasOwnProperty(code))) {
                        // 填入 content
                        let newEl = { ...el };
                        if (codeValueMap.hasOwnProperty(code)) {
                            newEl.content = codeValueMap[code];
                        }
                        // 填入 form_value_id 到 form_form_column_data[0]
                        if (Array.isArray(newEl.form_form_column_data) && newEl.form_form_column_data.length > 0 && codeFormValueIdMap.hasOwnProperty(code)) {
                            newEl.form_form_column_data = [
                                {
                                    ...newEl.form_form_column_data[0],
                                    form_value_id: codeFormValueIdMap[code]
                                }
                            ];
                        }
                        return newEl;
                    }
                    return el;
                })
            };
        });
    }

    // 把原本 getData 裡處理 response 的邏輯抽成獨立 function
    const initCanvasFromDocument = (data) => {
        // 加這行模擬 build 環境的 timing
        let dataFirst = data?.find(() => true)
        let document_classify_structure_type_data = dataFirst?.document_classify_structure_type_data || []
        let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((_) => true)
        let document_x_canvas_content_data = dataFirst?.document_x_canvas_content_data || []
        let document_x_canvas_content_first = document_x_canvas_content_data?.find((_) => true)
        let canvas_content = document_x_canvas_content_first?.content || []

        if (defaultRecord && axiosMode === "post") {
            canvas_content = canvas_content?.map(item => ({
                ...item,
                elements: item?.elements?.map(itemItem => ({
                    ...itemItem,
                    content: Object.keys(defaultRecord)?.includes(itemItem?.form_form_column_data?.[0]?.code)
                        ? defaultRecord?.[itemItem?.form_form_column_data?.[0]?.code]
                        : itemItem?.content
                }))
            }))
        }

        let document_form_data = document_classify_structure_type_data_first?.document_form_data || []
        let form_form_column_data = document_form_data?.find(() => true)?.form_form_column_data || []
        setColumns(form_form_column_data.map((value) => ({
            title: value?.code,
            key: String(value?.form_column_id),
            dataIndex: String(value?.form_column_id),
            align: "center",
        })))

        if (baseCanvasEdit2Ref.current) {
            baseCanvasEdit2Ref.current.onUpdate(canvas_content)
        }
        setCanvasElement(canvas_content)
        setDocumentId(document_classify_structure_type_data_first?.document_id || null)
    }
    useEffect(() => {
        if (preloadedDocument) {
            // ✅ 直接用預載資料初始化 canvas，不打 API
            initCanvasFromDocument(preloadedDocument)
            return
        }
        if (dbCoverId) {
            getData(dbCoverId)
        }
    }, [dbCoverId, preloadedDocument])

    // 若有 response_form_value_data 傳入，填入 canvasElement
    useEffect(() => {

        if (responseValue?.response_form_value_data && Array.isArray(canvasElement) && canvasElement.length > 0) {
            setCanvasElement((prev) => {
                let newData = fillCanvasElementWithResponse(prev, responseValue?.response_form_value_data)
                if (baseCanvasEdit2Ref.current) {
                    baseCanvasEdit2Ref.current.onUpdate(newData)
                }
                return prev
            });

        }
    }, [responseValue, canvasElement.length]);

    return (<Row>
        <Col span={24}>
            <Spin size={40} spinning={loading}>
                <div className="flex   bg-gray-50">
                    <TempDataProvider >
                        <div className="w-full">
                            <BaseCanvasEdit2
                                mode="fill"
                                propsCanvasMode={propsCanvasMode}
                                ref={baseCanvasEdit2Ref}
                                elements={canvasElement}
                                tools={[]}
                                onCanvasPageChange={(page) => {
                                    setTempCanvasElement(page)
                                }}
                                showToolbar={showToolbar}
                                autoFitWidth={autoFitWidth}
                                editableFieldCodes={editableFieldCodes}
                            />
                            {showSubmit && <div
                                className="sticky bottom-0 left-0 w-full flex justify-end p-4 bg-white shadow z-10"
                                style={{ marginTop: "0.5rem" }}
                            >
                                <Button
                                    type="primary"
                                    size="lg"
                                    onClick={handleSubmit}
                                >
                                    送出表單
                                </Button>
                            </div>}
                        </div>
                    </TempDataProvider>


                </div>
            </Spin>
        </Col>
    </Row>)
})
export default BaseDocumentResponseCanvasEdit
